import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  icon: {
    paddingLeft: 6,
    '& :hover': {
      color: '#26f7c5',
    },
  },
}));

export default useStyles;
